export default __webpack_public_path__ + "images/cf7fd7532ccc4be168f3e53f4033247c-rally.jpg";